module.exports = __webpack_public_path__ + "img/timer.452372d6.png";